import "babel-polyfill"
var ES6Promise = require("es6-promise")
ES6Promise.polyfill()
import _debounce from "lodash.debounce"

window.axios = require("axios")
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content
} else {
    console.error("CSRF token not found")
}

import bookshop from "./components/bookshop.js";
import Vue from "vue";
import store from "./store";
require("./components/index");
require("./vendor/fitvids.js");

window.onload = function() {
    fitVids(".video-container");
    bookshop.init();
}

import VueMasonry from "vue-masonry-css"
Vue.use(VueMasonry)

import * as VueGoogleMaps from "vue2-google-maps"
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyBevXnrkyXPZRVLo51UV_DnU4ADR9Ge2gE",
        libraries: "places",
    },
})

import VueSweetalert2 from "vue-sweetalert2"
Vue.use(VueSweetalert2)

const app = new Vue({
    el: "#app",
    store,

    data: {
        showNav: true,
        isBigEnough: true,
        width: null,
    },
    methods: {
        toggleNav() {
            this.showNav = !this.showNav
        },
        setVars() {
            this.width = window.innerWidth
            this.showNav = this.width >= 767
            this.isBigEnough = this.width >= 767
        },
    },
    mounted() {
        this.setVars()
        window.addEventListener(
            "resize",
            _debounce(() => {
                this.setVars()
            }, 500)
        )
        window.addEventListener(
            "orientationchange",
            _debounce(() => {
                this.setVars()
            }, 500)
        )
    },
})

import smoothscroll from "smoothscroll-polyfill"
smoothscroll.polyfill()

// Utilities
window.goBack = function() {
    window.history.back()
}

function externalLinks() {
    for (var c = document.getElementsByTagName("a"), a = 0; a < c.length; a++) {
        var b = c[a]
        b.getAttribute("href") &&
            b.hostname !== location.hostname &&
            (b.target = "_blank")
    }
}
externalLinks()

document.querySelectorAll("a[data-linktype='filedownload']").forEach(link => {
    link.addEventListener("mousedown", sendGaFileDownloadEvent)
})

let links = document.getElementsByTagName("a")
for (let link of links) {
    if (
        link.href.toLowerCase().endsWith(".pdf") ||
        link.href.toLowerCase().endsWith(".docx") ||
        link.href.toLowerCase().endsWith(".doc")
    ) {
        link.addEventListener("mousedown", sendGaFileDownloadEvent)
    }
}

function sendGaFileDownloadEvent(e) {
    let label = "";
    if (e.currentTarget.hasAttribute('data-filename') && e.currentTarget.dataset.filename) {
        label = e.currentTarget.dataset.filename;
    }
    else if (e.currentTarget.href) {
        label = e.currentTarget.href;
    }
    gtag('event', window.USER_ID, {
        'event_action': 'Download',
        'event_label': label
    });
}

var urlParams = new URLSearchParams(window.location.search);
var origin = urlParams.get('origin');

if (origin && origin == 'fira-international') {
    let popup = document.querySelector("#redirectPopup");
    popup.classList.remove('hidden');
}

let popupClose = [...document.querySelectorAll('.popup-close')];

if (popupClose.length) {
    popupClose.forEach(function(el) {
        el.addEventListener('click', function(e) {
            e.preventDefault();
            let popup = document.querySelector("#redirectPopup");
            popup.classList.add('hidden');
        });
    });
}

let notifCloseBtns = [...document.querySelectorAll('[data-cookies-close]')];

if (notifCloseBtns.length) {

    notifCloseBtns.forEach(el => {

        el.addEventListener('click', function(e) {
            e.preventDefault();

            var cookieId = el.dataset.cookiesClose;
            console.log(cookieId);

            // Set cookie for 365 days
            var cname = cookieId;
            var cvalue = "show";
            var d = new Date();
            d.setTime(d.getTime() + (365*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            // Hide message after setting cookie
            document.querySelector("[data-cookies='"+cookieId+"']").classList.add("hidden");
        });

    });

}

let tabHeaders = [...document.querySelectorAll('[data-tab-header]')];
let tabContent = [...document.querySelectorAll('[data-tab-content]')];

if (tabHeaders.length) {

    tabHeaders.forEach((el, index) => {

        if(index == 0) {
            el.classList.add('font-bold');
            el.classList.add('bg-grey-lighter');
            tabContent[index].classList.remove('hidden');
        }

        el.addEventListener('click', function(e) {
            e.preventDefault();

            tabHeaders.forEach(header => {
                header.classList.remove('font-bold');
                header.classList.remove('bg-grey-lighter');
            });

            el.classList.add('font-bold');
            el.classList.add('bg-grey-lighter');

            tabContent.forEach(tab => {
                if(el.dataset.tabHeader == tab.dataset.tabContent) {
                    tab.classList.remove('hidden');
                }
                else {
                    tab.classList.add('hidden');
                }
            });
        });

    });

}
